const PRODUCTS = [
  {
    id: "vpn",
    icon: "ri-shield-keyhole-line",
    tag: "Privacy & Security",
    name: "ALDEGO VPN",
    tagline: "Your Digital Shield",
    description:
      "A high-performance VPN application built natively for iOS, engineered to protect your online identity and encrypt all network traffic. Whether you&apos;re on public Wi-Fi or traveling abroad, ALDEGO VPN ensures your data stays private and your browsing remains unrestricted.",
    features: [
      "Military-grade AES-256 encryption",
      "Zero-log privacy policy",
      "Ultra-fast global server network",
      "Automatic kill-switch protection",
      "Split tunneling support",
    ],
    accent: "#00d4c8",
    image: "https://public.readdy.ai/ai/img_res/bc91ef89c398d39f602404ee5357b625.jpg",
  },
  {
    id: "cleaner",
    icon: "ri-sparkling-2-line",
    tag: "Performance & Optimization",
    name: "ALDEGO Cleaner",
    tagline: "Peak iOS Performance",
    description:
      "An intelligent device optimization tool that keeps your iPhone and iPad running at peak performance. ALDEGO Cleaner analyzes storage usage, removes junk files, and frees up valuable space — all with a beautifully simple interface designed for everyday users.",
    features: [
      "Smart junk file detection",
      "Duplicate photo & video finder",
      "Storage usage visualization",
      "Cache & temp file cleanup",
      "Memory optimization engine",
    ],
    accent: "#4dd0e1",
    image: "https://readdy.ai/api/search-image?query=abstract%20glowing%20sparkle%20clean%20sweep%20digital%20concept%20with%20teal%20blue%20light%20particles%20swirling%20on%20a%20deep%20black%20background%2C%20minimalist%20iOS%20app%20concept%20art%2C%20smooth%20gradient%20orbs%2C%20futuristic%20cleaning%20visualization%2C%20no%20text%2C%20ultra%20clean%20digital%20render%2C%20high%20quality%20sci-fi%20aesthetic&width=600&height=500&seq=cleaner002&orientation=landscape",
  },
];

export default function ProductsSection() {
  return (
    <section
      id="products"
      className="w-full py-32"
      style={{ background: "#080808" }}
    >
      <div className="max-w-7xl mx-auto px-8">
        {/* Header */}
        <div className="mb-4">
          <span className="text-[#00d4c8] text-xs font-bold tracking-[0.25em] uppercase">
            OUR SOLUTIONS
          </span>
        </div>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-20">
          <h2 className="text-5xl md:text-6xl font-extrabold text-white leading-tight">
            Products Designed
            <br />
            <span className="text-[#00d4c8]">for the Real World</span>
          </h2>
          <p className="text-[#7a7a7a] text-lg max-w-md leading-relaxed">
            Two powerful iOS applications focused on what matters most:
            your security and your device performance.
          </p>
        </div>

        {/* Product cards */}
        <div className="flex flex-col gap-8">
          {PRODUCTS.map((p, idx) => (
            <div
              key={p.id}
              className={`flex flex-col ${idx % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"} gap-0 rounded-3xl overflow-hidden border border-white/5 bg-[#111111] hover:border-[#00d4c8]/20 transition-all duration-500`}
            >
              {/* Image */}
              <div className="w-full md:w-1/2 h-72 md:h-auto overflow-hidden">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="w-full md:w-1/2 p-10 md:p-14 flex flex-col justify-center">
                {/* Tag */}
                <div className="inline-flex items-center gap-2 mb-6">
                  <div
                    className="w-8 h-8 flex items-center justify-center rounded-lg"
                    style={{ background: `${p.accent}18` }}
                  >
                    <i className={`${p.icon} text-lg`} style={{ color: p.accent }} />
                  </div>
                  <span className="text-xs font-semibold tracking-[0.15em] uppercase" style={{ color: p.accent }}>
                    {p.tag}
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-4xl font-extrabold text-white mb-1">{p.name}</h3>
                <p className="text-[#00d4c8]/70 text-sm font-medium tracking-wide uppercase mb-6">{p.tagline}</p>

                {/* Description */}
                <p
                  className="text-[#7a7a7a] text-base leading-relaxed mb-8"
                  dangerouslySetInnerHTML={{ __html: p.description }}
                />

                {/* Features */}
                <ul className="flex flex-col gap-3">
                  {p.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-3">
                      <div
                        className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0"
                        style={{ background: `${p.accent}20` }}
                      >
                        <i className="ri-check-line text-xs" style={{ color: p.accent }} />
                      </div>
                      <span className="text-[#b0b0b0] text-sm">{feat}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
